import React from 'react';
import MyComponent from './App3.0.jsx';

function App() {
  return (
    <div>
      <MyComponent />
    </div>
  );
}

export default App;
